<div
  *ngIf="control"
  #container
  [class.row]="inline"
>
  <label  class="form-label "
          [class.col-form-label]="inline"
          [class.col-sm-3]="inline"
          [for]="name"
  >{{ label }}

    <ng-container *ngIf="tooltipText">
      <span><i [tooltip]="tooltipText" class="fa fa-info-circle"></i></span>
    </ng-container>
  </label>

  <div [class.col-sm-9]="inline">
    <div class="input-group"  >
    <span *ngIf="prefix" class="input-group-text">
      {{ prefix }}
    </span>

      <div class="toolbar">
        <button
          type="button"
          class="right"
          (click)="toggleHardLineBreak()"
          tooltip="{{ 'shared.components.markdown_editor.toolbar.line_break' | translate }}"
        >
          <i class="fa-solid fa-paragraph"></i>
        </button>
        <button
          type="button"
          class="right"
          (click)="toggleBold()"
          tooltip="{{ 'shared.components.markdown_editor.toolbar.bold' | translate }}"
        >
          <i class="fa-solid fa-bold"></i>
        </button>
        <button
          type="button"
          class="right"
          (click)="toggleItalic()"
          tooltip="{{ 'shared.components.markdown_editor.toolbar.italic' | translate }}"
        >
          <i class="fa-solid fa-italic"></i>
        </button>
        <button
          type="button"
          class="right"
          (click)="toggleStrike()"
          tooltip="{{ 'shared.components.markdown_editor.toolbar.strike' | translate }}"
        >
          <i class="fa-solid fa-strikethrough"></i>
        </button>
        <button
          type="button"
          class="right"
          (click)="openLinkModal(linkInput)"
          tooltip="{{ 'shared.components.markdown_editor.toolbar.link' | translate }}"
        >
          <i class="fa-solid fa-link"></i>
        </button>
        <button
          type="button"
          class="right"
          (click)="openEmailLinkModal(emailLinkInput)"
          tooltip="{{ 'shared.components.markdown_editor.toolbar.email_link' | translate }}"
        >
          <i class="fa-solid fa-at"></i>
        </button>


        <button
          type="button"
          class="left float-end"
          (click)="openKeyboardShortcuts(keyboardShortcuts)"
          tooltip="{{ 'shared.components.markdown_editor.shortcuts.title' | translate }}"
        >
          <i class="fa-regular fa-keyboard"></i>
        </button>
      </div>



      <div class="editor-container" #editorContainerRef></div>

      <div class="text-danger py-1 small" *ngIf="!!control.getError('serverError')">{{ control.getError('serverError') }}</div>

      <ng-container *ngFor="let err of control.errors | keyvalue">
        <ng-container *ngIf="(control.touched && control.invalid)">
          <div *ngIf="errorMessages && errorMessages[err.key] " class="invalid-feedback">
            {{ errorMessages[err.key] }}
          </div>
          <div *ngIf="(!errorMessages || !errorMessages[err.key] ) && err.key !== 'serverError'" class="invalid-feedback">
            {{ 'forms.errors.' + err.key | translate }}
          </div>
        </ng-container>

      </ng-container>


    </div>
  </div>
</div>

<ng-template #keyboardShortcuts>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ 'shared.components.markdown_editor.shortcuts.title' | translate }}</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="keyboardShordcutsModal?.hide()">
      <i class="fa-solid fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <table class="markdown-editor-keyboard-shortcuts-table">
        <tr *ngFor="let shortcut of ('shared.components.markdown_editor.shortcuts.list' | translate)">
          <td><b>{{ shortcut.name }}</b></td>
          <td>{{ shortcut.key }}</td>
        </tr>
    </table>
  </div>
</ng-template>

<ng-template #linkInput>
  <div class="modal-body">
    <div>
      <button type="button" class="bg-transparent border-0 float-end" aria-label="Close" (click)="linkInputModal?.hide()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
    <app-form-group
      [formControl]="linkInputFormControl"
      name="link_input"
      label="{{ 'shared.components.markdown_editor.link_input_label' | translate }}"
    ></app-form-group>
    <div>
      <button type="button" class="btn btn-primary w-100" (click)="toggleLink()">
        {{ 'shared.components.markdown_editor.add_link' | translate }}
      </button>
    </div>
  </div>
</ng-template>


<ng-template #emailLinkInput>
  <div class="modal-body">
    <div>
      <button type="button" class="bg-transparent border-0 float-end" aria-label="Close" (click)="emailLinkModal?.hide()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
    <app-form-group
      [formControl]="emailLinkInputFormControl"
      name="link_input"
      label="{{ 'shared.components.markdown_editor.email_link_input_label' | translate }}"
    ></app-form-group>
    <div>
      <button type="button" class="btn btn-primary w-100" (click)="toggleEmailLink()">
        {{ 'shared.components.markdown_editor.add_email_link' | translate }}
      </button>
    </div>
  </div>
</ng-template>
